const carouselItems = [
  {
    id: 1,
    title: '暑期档必看清单',
    tag: '编辑精选',
    desc: '今年暑期档最强片单集结！从国产动画巨制到好莱坞视效大片，我们为你甄选了暑期最值得观看的 20 部影片。每一部都经过团队反复筛选，确保品质与口碑兼具，陪你度过一个精彩的电影之夏。',
    img: 'https://readdy.ai/api/search-image?query=Summer%20cinema%20themed%20collage%20with%20film%20strips%2C%20popcorn%2C%20movie%20tickets%2C%20vintage%20camera%2C%20warm%20sunset%20colors%2C%20golden%20hour%20lighting%2C%20nostalgic%20film%20aesthetic%2C%20artistic%20flat%20lay%20composition%2C%20cinema%20paraphernalia%2C%20rich%20textures&width=800&height=450&seq=carousel-summer&orientation=landscape',
  },
  {
    id: 2,
    title: '豆瓣 9 分神作合集',
    tag: '口碑佳作',
    desc: '豆瓣评分 9.0 以上的华语影视精品一次看完。从《大明王朝1566》到《甄嬛传》，从《霸王别姬》到《活着》，这些经过时间检验的神作代表了华语影视的最高水准。每一部都值得反复品味，常看常新。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20library%20with%20tall%20wooden%20bookshelves%20filled%20with%20film%20books%2C%20warm%20reading%20lamp%20light%2C%20vintage%20movie%20posters%20on%20walls%2C%20classic%20cinema%20books%20collection%2C%20rich%20brown%20and%20gold%20tones%2C%20scholarly%20atmosphere%2C%20intellectual%20cinema%20culture&width=800&height=450&seq=carousel-rating&orientation=landscape',
  },
  {
    id: 3,
    title: '2025 年度期待新片',
    tag: '即将上线',
    desc: '抢先了解年度最值得期待的影视新作！从好莱坞续集大片到国产原创力作，我们整理了全年最受关注的影视项目动态与上映时间表。第一时间掌握影讯风向标，锁定你的必看清单。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20calendar%20desk%20setup%20with%20cinema%20ticket%20stubs%20pinned%20on%20cork%20board%2C%20film%20schedule%20planner%2C%20warm%20desk%20lamp%2C%20coffee%20cup%2C%20clean%20aesthetic%2C%20soft%20morning%20light%2C%20organized%20creative%20workspace&width=800&height=450&seq=carousel-upcoming&orientation=landscape',
  },
  {
    id: 4,
    title: '冷门佳片挖掘计划',
    tag: '小众宝藏',
    desc: '那些评分高但鲜为人知的冷门佳作，往往藏着最打动人心的故事。我们深入世界各地的电影节与独立制片领域，为你打捞那些被主流视野忽视的珍珠。每发现一部，都是惊喜。',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20independent%20cinema%20interior%20with%20red%20velvet%20seats%2C%20dim%20warm%20lighting%2C%20small%20arthouse%20theater%20atmosphere%2C%20vintage%20film%20posters%2C%20intimate%20setting%2C%20rich%20red%20and%20amber%20tones%2C%20nostalgic%20boutique%20cinema&width=800&height=450&seq=carousel-indie&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium tracking-wide mb-3">
            深度策划
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            精选专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-2 max-w-lg mx-auto">
            编辑团队精心打造的影视专题，深入发现好内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {carouselItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer transition-all hover:border-primary-200"
            >
              <div className="relative h-52 md:h-60 overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <span className="absolute top-4 left-4 inline-block px-3 py-1 rounded-full bg-primary-500/90 text-white text-xs font-medium">
                  {item.tag}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-sm md:text-base leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}